export const stepOneData = [
  {
    heading: "Why Use the Car Loan EMI Calculator?",
    // paras before heading

    infoList: [
      {
        heading: "Accuracy: ",
        description:
          "Get precise EMI and total repayment estimates tailored to your car loan.",
      },
      {
        heading: "Flexibility: ",
        description:
          "Test various loan scenarios by adjusting the loan amount, interest rate, and tenure.",
      },
      {
        heading: "Transparency: ",
        description:
          "Understand the breakdown of your loan’s principal and interest amounts.",
      },
      {
        heading: "Convenience: ",
        description:
          "Access the EMI calculator online, free of charge, anytime, anywhere.",
      },
    ],
    tip: "Check for Hidden Fees: Be aware of processing fees, late payment charges, and other hidden costs that could affect your total loan cost.",
  },
];

export const stepTwoData = [
  {
    heading: "Features of Car Loans with HDFC Bank",

    tableContent: {
      heading: [
        {
          head: "Loan Type",
        },
        {
          head: "Interest Rate (Starting)",
        },
        {
          head: "Maximum Tenure",
        },
        {
          head: "Processing Fees",
        },
      ],
      row: [
        {
          type: "Car Loan",
          interest: "8.60% p.a.",
          tenure: "Up to 7 years",
          fee: "0.5%-1.0% of loan amount",
        },
      ],
    },
  },
];

export const stepThreeData = [
  {
    heading: "Benefits of Using the Car Loan EMI Calculator",

    factorsList: [
      {
        heading: "Better Financial Planning: ",
        info: "Easily determine a loan amount and tenure that fits your budget without surprises.",
      },
      {
        heading: "Cost Comparison: ",
        info: "Compare different car loan options from HDFC Bank and other lenders to find the best rates and terms.",
      },
      {
        heading: "Quick Access: ",
        info: "Use the calculator from the comfort of your home, saving time and hassle.",
      },
      {
        heading: "Instant Results: ",
        info: "Receive immediate insights that allow for quick decisions in your car loan journey.",
      },
    ],
    tip: "Choose a Balanced Loan Tenure: Opt for a tenure that balances a manageable EMI with a reasonable total repayment amount",
  },
];

export const stepFourData = [
  {
    heading: "Factors Influencing Your EMI with HDFC Bank",

    factorsList: [
      {
        heading: "Loan Amount: ",
        info: "A higher loan amount will increase your monthly EMI.",
      },
      {
        heading: "Interest Rate: ",
        info: "Lower rates help reduce EMIs and the total cost of the loan.",
      },
      {
        heading: "Tenure: ",
        info: "Longer tenures mean smaller EMIs but higher total interest payments.",
      },
      {
        heading: "Processing Fees: ",
        info: "Factor in the processing fees, as they contribute to the overall cost of your loan.",
      },
      {
        heading: "Prepayment Options: ",
        info: "Prepaying your loan can reduce the principal, which directly lowers the EMI and overall loan tenure.",
      },
    ],
    tip: "Negotiate the Interest Rate: If you have a good credit score, negotiate with the lender for a more competitive rate",
  },
];
export const stepFiveData = [
  {
    heading: "How to Use the Car Loan EMI Calculator",
    tip: "Minimize Interest Costs: A higher down payment can reduce the principal, leading to lower EMI and interest costs over the loan term.",
  },
];
export const stepSixData = [
  {
    heading: "How the Loan Tenure Affects Your EMI",
    tableContent: {
      heading: [
        {
          head: "Loan Tenure",
        },
        {
          head: "Monthly EMI",
        },
        {
          head: "Total Interest Paid",
        },
        {
          head: "Total Repayment",
        },
      ],
      row: [
        {
          tenure: "5 years",
          emi: "Higher	",
          interest: "Lower",
          repayment: "Lower",
        },
        {
          tenure: "7 years	",
          emi: "Moderate",
          interest: "Moderate",
          repayment: "Moderate",
        },
        {
          tenure: "10 years",
          emi: "Lower	",
          interest: "Higher",
          repayment: "Higher",
        },
      ],
    },
    tip: "Consider Loan Prepayment Options: If your financial situation improves, consider making partial prepayments to reduce the principal and overall interest.",
  },
];
export const stepSevenData = [
  {
    heading: "MinEmi Tips for Axis Bank Borrowers",
    infoList: [
      {
        head: "Consider the Annual Percentage Rate (APR): ",
        info: "APR gives a comprehensive picture, including the interest rate and other fees.",
      },
      {
        head: "Negotiate for Lower Interest Rates: ",
        info: "A high credit score or an existing relationship with Axis Bank can help secure better terms.",
      },
      {
        head: "Choose the Right Loan Tenure: ",
        info: "Balance affordability (lower EMI) with total cost (lower interest).",
      },
      {
        head: "Review All Terms and Conditions: ",
        info: "Understand fees, prepayment options, and penalties before finalizing the loan.",
      },
    ],
  },
];
